import { Component, Input } from '@angular/core';

@Component({
  selector: 'hf-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent {
  @Input()
  public iconName: string;
}
